export default "__VITE_ASSET__CSfbfvjf__"